import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content p-0" }
const _hoisted_2 = { class: "d-flex align-items-center flex-md-row flex-column gap-20 w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column gap-15 w-100" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-base" }, " Verification "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-light sm-fs-sm" }, " (Note: Password should be the same as used for logging in)")
], -1)
const _hoisted_4 = { class: "w-100 d-flex align-items-center justify-content-between gap-4 sm-mb-100" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: _ctx.errors?.General
    }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DateInput, {
          label: "Date",
          modelValue: _ctx.data.Date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.Date) = $event)),
          readonly: true
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "IP Address",
          max: 50,
          modelValue: _ctx.data.IPAddress,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.IPAddress) = $event)),
          readonly: true
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_3,
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        label: "Name",
        max: 50,
        modelValue: _ctx.data.Name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.Name) = $event)),
        "is-required": true,
        error: _ctx.errors.Name
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_TextInput, {
        type: "password",
        label: "Password",
        max: 100,
        modelValue: _ctx.data.Password,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.Password) = $event)),
        "is-required": true,
        error: _ctx.errors.Password
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn btn-secondary sm-mb-20",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args))),
        disabled: _ctx.loadingSubmit
      }, "Back", 8, _hoisted_5),
      _createElementVNode("button", {
        class: "btn btn-primary sm-mb-20",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args))),
        disabled: _ctx.loadingSubmit
      }, "Verification", 8, _hoisted_6)
    ])
  ], 64))
}